var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClasses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 17.79,
    viewBox: "0 0 19.5 17.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "book-open-svgrepo-com",
    d: "M12,10.4V20m0-9.6c0-2.24,0-3.36-.436-4.216A4,4,0,0,0,9.816,4.436C8.96,4,7.84,4,5.6,4h-1a2.484,2.484,0,0,0-1.054.109,1,1,0,0,0-.437.437A2.484,2.484,0,0,0,3,5.6V16.4a2.484,2.484,0,0,0,.109,1.054,1,1,0,0,0,.437.437A2.484,2.484,0,0,0,4.6,18H7.547a6.3,6.3,0,0,1,1.071.047,2.994,2.994,0,0,1,.674.2,6.3,6.3,0,0,1,.917.556L12,20m0-9.6c0-2.24,0-3.36.436-4.216a4,4,0,0,1,1.748-1.748C15.04,4,16.16,4,18.4,4h1a2.484,2.484,0,0,1,1.054.109,1,1,0,0,1,.437.437A2.484,2.484,0,0,1,21,5.6V16.4a2.484,2.484,0,0,1-.109,1.054,1,1,0,0,1-.437.437A2.484,2.484,0,0,1,19.4,18H16.453a6.3,6.3,0,0,0-1.071.047,2.993,2.993,0,0,0-.674.2,6.3,6.3,0,0,0-.917.556L12,20",
    transform: "translate(-2.25 -3.25)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClasses);
export default __webpack_public_path__ + "static/media/Classes.df437d14a9cb74ee78262721ebcba38b.svg";
export { ForwardRef as ReactComponent };